import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { isNil } from 'lodash';
import { from, Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { AuthService } from '../../services/user/auth/auth.service';
import { RolesService } from '../../services/user/roles/roles.service';

@Injectable({
  providedIn: 'root',
})
export class AdminGuard  {
  constructor(
    private rolesService: RolesService,
    private authService: AuthService,
    private router: Router,
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const observable = this.authService.getUserId().pipe(
      switchMap((userId) => this.rolesService.getDoc(userId)),
      switchMap((roles) => {
        if (isNil(roles) || !roles.isOrgAdmin()) {
          console.log('AdminGuard: User is not permitted to access this route');
          return from(this.router.navigate(['/'])).pipe(map((_) => roles.isOrgAdmin()));
        }
        console.log('AdminGuard: User is orgAdmin');
        return of(roles.isOrgAdmin());
      }),
    );
    return observable;
  }
}
